const KWT = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    viewBox="0 0 512 512"
    {...props}
  >
    <mask id="a">
      <circle cx="256" cy="256" r="256" fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#eee" d="M138.4 147 512 167v178l-373.6 20z" />
      <path fill="#6da544" d="m0 0 138.4 167H512V0z" />
      <path fill="#d80027" d="m0 512 138.4-167H512v167z" />
      <path fill="#333" d="M167 167 0 0v512l167-167z" />
    </g>
  </svg>
);
export default KWT;
